// extracted by mini-css-extract-plugin
module.exports = {"container":"duplicatedPeople_container_1om3w","content":"duplicatedPeople_content_2xBDE"};